(() => {
  if (customElements.get("cart-terms")) return;

  const STORAGE_KEY = "aurio:cart-terms-accepted";

  // Kept in memory as well as sessionStorage so the checked state survives
  // cart drawer / cart page re-renders even when storage is unavailable.
  let accepted = false;
  try {
    accepted = window.sessionStorage.getItem(STORAGE_KEY) === "true";
  } catch (e) {}

  const setAccepted = (value) => {
    accepted = value;
    try {
      window.sessionStorage.setItem(STORAGE_KEY, String(value));
    } catch (e) {}
  };

  class CartTerms extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector(".wt-cart__terms__input");
      this.error = this.querySelector(".wt-cart__terms__error");
      if (!this.input) return;

      this.input.checked = accepted;

      // Drawer re-renders arrive with tabindex="-1"; make the controls
      // reachable again when the drawer is already open.
      const drawer = this.closest("cart-drawer");
      if (drawer && drawer.hasAttribute("open")) {
        this.querySelectorAll("input, a").forEach((el) =>
          el.setAttribute("tabindex", "0"),
        );
      }

      this.onChange = () => {
        setAccepted(this.input.checked);
        if (this.input.checked) this.clearError();
      };
      this.input.addEventListener("change", this.onChange);
    }

    disconnectedCallback() {
      this.input?.removeEventListener("change", this.onChange);
    }

    get isAccepted() {
      return Boolean(this.input?.checked);
    }

    showError() {
      this.input.setAttribute("aria-invalid", "true");
      this.classList.add("wt-cart__terms--invalid");
      this.error.textContent = this.dataset.errorMessage || "";
      this.input.focus();
    }

    clearError() {
      this.input.setAttribute("aria-invalid", "false");
      this.classList.remove("wt-cart__terms--invalid");
      this.error.textContent = "";
    }
  }

  customElements.define("cart-terms", CartTerms);

  // Delegated at document level so it keeps working after the cart drawer
  // and cart page sections replace their markup.
  const findTerms = (button) =>
    button
      .closest(".wt-cart__drawer__footer, .wt-cart__footer")
      ?.querySelector("cart-terms");

  const guard = (event, button) => {
    if (!button || button.name !== "checkout") return;
    const terms = findTerms(button);
    if (!terms || terms.isAccepted) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    terms.showError();
  };

  document.addEventListener(
    "click",
    (event) => guard(event, event.target.closest?.('button[name="checkout"]')),
    true,
  );

  document.addEventListener(
    "submit",
    (event) => guard(event, event.submitter),
    true,
  );
})();
